import { Link } from "react-router-dom";

export const Logo = ({ size = "text-2xl", accent = true, testid = "brand-logo" }) => (
  <Link to="/" data-testid={testid} className={`font-display ${size} leading-none tracking-tight whitespace-nowrap select-none`}>
    DEN <span className={accent ? "text-neon" : ""}>&amp;</span> THREADS
  </Link>
);

export const SectionHead = ({ eyebrow, title, action, className = "" }) => (
  <div className={`flex items-end justify-between gap-6 mb-10 ${className}`}>
    <div>
      {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">{title}</h2>
    </div>
    {action}
  </div>
);
